import styled from "styled-components"

export const CardResults = styled.div `

    width: 100%;
    height: fit-content;
    display: grid;

`